/**
 * SGKE361A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SuppntInfo {

    /**
     * 供給地点特定番号
     */
    suppntSpno?: string;
    /**
     * 供給停止再開履歴番号
     */
    supplystopresumptionRrkno?: string;
    /**
     * エネルギー種別コード
     */
    energyClscode?: string;
    /**
     * エネルギー種別コード名称
     */
    energyClsfyCodeaname?: string;
    /**
     * 契約お客さま番号
     */
    firstSrvctrNo?: string;
    /**
     * 使用者名漢字
     */
    userMeiKanji?: string;
    /**
     * 使用者名カナ
     */
    userMeiKana?: string;
    /**
     * 作業種別コード
     */
    workClscode?: string;
    /**
     * 作業種別コード名称
     */
    workClscodeAname?: string;
    /**
     * 再開手段コード
     */
    resumeWayCode?: string;
    /**
     * 再開手段コード名称
     */
    resumeWayCodeaname?: string;
    /**
     * メーター番号
     */
    meterNo?: string;
    /**
     * メーター型
     */
    meterKata?: string;
    /**
     * メーター能力
     */
    meterAbility?: number;
    /**
     * メーター分類コード
     */
    meterBunruiCode?: string;
    /**
     * メーター識別
     */
    meterDiscrm?: string;
    /**
     * メーター識別名称
     */
    meterDiscrmAname?: string;
    /**
     * 総合区分コード
     */
    sougouDivcd?: string;
    /**
     * 総合区分コード名称
     */
    sougoudivCodeAname?: string;
    /**
     * 総合供給先番号
     */
    sougouSupplydestinationNo?: string;
    /**
     * サービス契約番号
     */
    srvCtrNo?: string;
    /**
     * 使用お客さま番号
     */
    logicDeviceNo?: string;
    /**
     * 供給停止再開ステータス
     */
    supplystopResumeSts?: string;
    /**
     * 初期設定作業予定日付
     */
    initialsetupWorkScddt?: string;
    /**
     * 作業中断初回登録時刻
     */
    worksuspensionFirstRegistrationtime?: string;
    /**
     * 使用場所住所
     */
    empposAddr?: string;
    /**
     * 供給再開作業担当ユーザID
     */
    supplyresumptionWorkchargeUserid?: string;
    /**
     * 供給再開作業担当者名
     */
    supplyresumptionWorkTantoshaname?: string;
    /**
     * 作業場所コード
     */
    workPlaceCode?: string;
    /**
     * 督促料金番号
     */
    pressChargenumber?: string;
    /**
     * 供給停止強制有無フラグ
     */
    supplystopForceEonflg?: string;
}

